import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=086f2936&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=086f2936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f2936",
  null
  
)

export default component.exports